import { Injectable } from '@angular/core';
import { DwEventService, DwLoggingService, DwOrmDataService, DwSecurityStateService } from '@devwareapps/devware-cap';
import { EMPTY, timer } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap, take, tap } from 'rxjs/operators';
import { AppMetaDataItemNames } from '../../../meta-data/app-meta-data.service';
import { IntegrationUtilService } from '../../integration/services/integration-util.service';
import { PaymentsRepositoryService } from './payments-repository.service';
import { COURSE_PURCHASED_EVENT } from './payments-purchase.service';

@Injectable({ providedIn: 'root' })
export class DelayedCheckoutRecoveryService {
  private started = false;

  constructor(
    private securityStateService: DwSecurityStateService,
    private repository: PaymentsRepositoryService,
    private integrationUtilService: IntegrationUtilService,
    private eventService: DwEventService,
    private loggingService: DwLoggingService
  ) { }

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;

    // App-scoped so routing away from signup does not cancel the delay.
    this.securityStateService.securityStateObservable.pipe(
      map(state => {
        const userId = state.securityContext?.AuthenticatedUser?.UserId;
        return state.isAuthenticated && userId === state.securityContext?.ApplicationUser?.UserId ? userId : null;
      }),
      distinctUntilChanged(),
      // Logout or a different application user cancels pending recovery.
      switchMap(userId => userId ? timer(20000).pipe(
        switchMap(() => this.integrationUtilService.waitForIntegrationWorkflow()),
        take(1),
        switchMap(() => this.repository.recoverCheckout()),
        tap(() => {
          this.eventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.StudentCourse), {});
          this.eventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.Course), {});
          this.eventService.publishEvent(COURSE_PURCHASED_EVENT, {});
        }),
        catchError(error => {
          this.loggingService.logError('Delayed checkout recovery failed', error, null, true);
          return EMPTY;
        })
      ) : EMPTY)
    ).subscribe();
  }
}
